
export { default as icon_3d_cube } from './src/icons/icon_3d_cube.svg'
export { default as customisable_equaliser_icon } from './src/icons/customisable_equaliser_icon.svg'
export { default as icon_3d_text } from './src/icons/icon_3d_text.svg'
export { default as icon_3d } from './src/icons/icon_3d.svg'
export { default as icon_accessibility } from './src/icons/icon_accessibility.svg'
export { default as icon_admin } from './src/icons/icon_admin.svg'
export { default as icon_amazon_alexa } from './src/icons/icon_amazon_alexa.svg'
export { default as icon_anc } from './src/icons/icon_anc.svg'
export { default as icon_arrow_down } from './src/icons/icon_arrow_down.svg'
export { default as icon_arrow_left } from './src/icons/icon_arrow_left.svg'
export { default as icon_arrow_right } from './src/icons/icon_arrow_right.svg'
export { default as icon_arrow_up } from './src/icons/icon_arrow_up.svg'
export { default as icon_bass } from './src/icons/icon_bass.svg'
export { default as icon_battery_charging_percent_1 } from './src/icons/icon_battery_charging_percent_1.svg'
export { default as icon_battery_charging_percent_20 } from './src/icons/icon_battery_charging_percent_20.svg'
export { default as icon_battery_charging_percent_40 } from './src/icons/icon_battery_charging_percent_40.svg'
export { default as icon_battery_charging_percent_60 } from './src/icons/icon_battery_charging_percent_60.svg'
export { default as icon_battery_charging_percent_80 } from './src/icons/icon_battery_charging_percent_80.svg'
export { default as icon_battery_charging_percent_100 } from './src/icons/icon_battery_charging_percent_100.svg'
export { default as icon_battery_not_charging_percent_1 } from './src/icons/icon_battery_not_charging_percent_1.svg'
export { default as icon_battery_not_charging_percent_20 } from './src/icons/icon_battery_not_charging_percent_20.svg'
export { default as icon_battery_not_charging_percent_40 } from './src/icons/icon_battery_not_charging_percent_40.svg'
export { default as icon_battery_not_charging_percent_60 } from './src/icons/icon_battery_not_charging_percent_60.svg'
export { default as icon_battery_not_charging_percent_80 } from './src/icons/icon_battery_not_charging_percent_80.svg'
export { default as icon_battery_not_charging_percent_100 } from './src/icons/icon_battery_not_charging_percent_100.svg'
export { default as icon_bluetooth_oval } from './src/icons/icon_bluetooth_oval.svg'
export { default as icon_bluetooth } from './src/icons/icon_bluetooth.svg'
export { default as icon_boom_arm_down } from './src/icons/icon_boom_arm_down.svg'
export { default as icon_boom_arm_movement } from './src/icons/icon_boom_arm_movement.svg'
export { default as icon_boom_arm_up } from './src/icons/icon_boom_arm_up.svg'
export { default as icon_brightness_high } from './src/icons/icon_brightness_high.svg'
export { default as icon_brightness_low } from './src/icons/icon_brightness_low.svg'
export { default as icon_burger } from './src/icons/icon_burger.svg'
export { default as icon_busylight_in_call } from './src/icons/icon_busylight_in_call.svg'
export { default as icon_busylight } from './src/icons/icon_busylight.svg'
export { default as icon_calendar } from './src/icons/icon_calendar.svg'
export { default as icon_call_end } from './src/icons/icon_call_end.svg'
export { default as icon_call_hold } from './src/icons/icon_call_hold.svg'
export { default as icon_call_incoming } from './src/icons/icon_call_incoming.svg'
export { default as icon_call_reject } from './src/icons/icon_call_reject.svg'
export { default as icon_call_switch } from './src/icons/icon_call_switch.svg'
export { default as icon_call } from './src/icons/icon_call.svg'
export { default as icon_camera } from './src/icons/icon_camera.svg'
export { default as icon_case } from './src/icons/icon_case.svg'
export { default as icon_chevron_down } from './src/icons/icon_chevron_down.svg'
export { default as icon_chevron_left } from './src/icons/icon_chevron_left.svg'
export { default as icon_chevron_narrow } from './src/icons/icon_chevron_narrow.svg'
export { default as icon_chevron_right } from './src/icons/icon_chevron_right.svg'
export { default as icon_chevron_up } from './src/icons/icon_chevron_up.svg'
export { default as icon_clear_fill } from './src/icons/icon_clear_fill.svg'
export { default as icon_clear } from './src/icons/icon_clear.svg'
export { default as icon_clock } from './src/icons/icon_clock.svg'
export { default as icon_close_small } from './src/icons/icon_close_small.svg'
export { default as icon_close_medium } from './src/icons/icon_close_medium.svg'
export { default as icon_close_large } from './src/icons/icon_close_large.svg'
export { default as icon_conversation } from './src/icons/icon_conversation.svg'
export { default as icon_copy } from './src/icons/icon_copy.svg'
export { default as icon_customer_support } from './src/icons/icon_customer_support.svg'
export { default as icon_device_menu } from './src/icons/icon_device_menu.svg'
export { default as icon_dolby_mini } from './src/icons/icon_dolby_mini.svg'
export { default as icon_dongle } from './src/icons/icon_dongle.svg'
export { default as icon_download } from './src/icons/icon_download.svg'
export { default as icon_ear } from './src/icons/icon_ear.svg'
export { default as icon_edit } from './src/icons/icon_edit.svg'
export { default as icon_error } from './src/icons/icon_error.svg'
export { default as icon_fallback } from './src/icons/icon_fallback.svg'
export { default as icon_filter } from './src/icons/icon_filter.svg'
export { default as icon_fireworks } from './src/icons/icon_fireworks.svg'
export { default as icon_fwu_available } from './src/icons/icon_fwu_available.svg'
export { default as icon_fwu_in_progress } from './src/icons/icon_fwu_in_progress.svg'
export { default as icon_gitt } from './src/icons/icon_gitt.svg'
export { default as icon_globe } from './src/icons/icon_globe.svg'
export { default as icon_grab } from './src/icons/icon_grab.svg'
export { default as icon_headset_boom_arm } from './src/icons/icon_headset_boom_arm.svg'
export { default as icon_headset_mono } from './src/icons/icon_headset_mono.svg'
export { default as icon_headset_name } from './src/icons/icon_headset_name.svg'
export { default as icon_headset_wearing } from './src/icons/icon_headset_wearing.svg'
export { default as icon_headset } from './src/icons/icon_headset.svg'
export { default as icon_headtracking } from './src/icons/icon_headtracking.svg'
export { default as icon_hearthrough } from './src/icons/icon_hearthrough.svg'
export { default as icon_hide } from './src/icons/icon_hide.svg'
export { default as icon_hold_four_seconds } from './src/icons/icon_hold_four_seconds.svg'
export { default as icon_hold_one_second } from './src/icons/icon_hold_one_second.svg'
export { default as icon_hold_three_seconds } from './src/icons/icon_hold_three_seconds.svg'
export { default as icon_hold_two_seconds } from './src/icons/icon_hold_two_seconds.svg'
export { default as icon_home } from './src/icons/icon_home.svg'
export { default as icon_imagequality } from './src/icons/icon_imagequality.svg'
export { default as icon_in_ear_detected } from './src/icons/icon_in_ear_detected.svg'
export { default as icon_in_ear_not_detected } from './src/icons/icon_in_ear_not_detected.svg'
export { default as icon_intelligent_zoom } from './src/icons/icon_intelligent_zoom.svg'
export { default as icon_kebab_horizontal } from './src/icons/icon_kebab_horizontal.svg'
export { default as icon_kebab_vertical } from './src/icons/icon_kebab_vertical.svg'
export { default as icon_laptop } from './src/icons/icon_laptop.svg'
export { default as icon_left_earbud } from './src/icons/icon_left_earbud.svg'
export { default as icon_left_right } from './src/icons/icon_left_right.svg'
export { default as icon_left } from './src/icons/icon_left.svg'
export { default as icon_legal } from './src/icons/icon_legal.svg'
export { default as icon_lightbulb } from './src/icons/icon_lightbulb.svg'
export { default as icon_list } from './src/icons/icon_list.svg'
export { default as icon_location_pin } from './src/icons/icon_location_pin.svg'
export { default as icon_lock_filled } from './src/icons/icon_lock_filled.svg'
export { default as icon_lock } from './src/icons/icon_lock.svg'
export { default as icon_log_out } from './src/icons/icon_log_out.svg'
export { default as icon_manual_zoom } from './src/icons/icon_manual_zoom.svg'
export { default as icon_microphone_quality } from './src/icons/icon_microphone_quality.svg'
export { default as icon_microphone } from './src/icons/icon_microphone.svg'
export { default as icon_microsoft_teams } from './src/icons/icon_microsoft_teams.svg'
export { default as icon_minus_filled } from './src/icons/icon_minus_filled.svg'
export { default as icon_minus_small } from './src/icons/icon_minus_small.svg'
export { default as icon_minus } from './src/icons/icon_minus.svg'
export { default as icon_more_information } from './src/icons/icon_more_information.svg'
export { default as icon_move_folder } from './src/icons/icon_move_folder.svg'
export { default as icon_move } from './src/icons/icon_move.svg'
export { default as icon_music } from './src/icons/icon_music.svg'
export { default as icon_muted } from './src/icons/icon_muted.svg'
export { default as icon_my_fit } from './src/icons/icon_my_fit.svg'
export { default as icon_network } from './src/icons/icon_network.svg'
export { default as icon_next_track } from './src/icons/icon_next_track.svg'
export { default as icon_no_functionality } from './src/icons/icon_no_functionality.svg'
export { default as icon_noise_reduction } from './src/icons/icon_noise_reduction.svg'
export { default as icon_notifications } from './src/icons/icon_notifications.svg'
export { default as icon_number_eight } from './src/icons/icon_number_eight.svg'
export { default as icon_number_five } from './src/icons/icon_number_five.svg'
export { default as icon_number_four } from './src/icons/icon_number_four.svg'
export { default as icon_number_nine } from './src/icons/icon_number_nine.svg'
export { default as icon_number_one } from './src/icons/icon_number_one.svg'
export { default as icon_number_seven } from './src/icons/icon_number_seven.svg'
export { default as icon_number_six } from './src/icons/icon_number_six.svg'
export { default as icon_number_three } from './src/icons/icon_number_three.svg'
export { default as icon_number_two } from './src/icons/icon_number_two.svg'
export { default as icon_number_zero } from './src/icons/icon_number_zero.svg'
export { default as icon_off } from './src/icons/icon_off.svg'
export { default as icon_on_ear_detection } from './src/icons/icon_on_ear_detection.svg'
export { default as icon_on_ear_not_detected } from './src/icons/icon_on_ear_not_detected.svg'
export { default as icon_on_in_ear_detection } from './src/icons/icon_on_in_ear_detection.svg'
export { default as icon_open_new_window } from './src/icons/icon_open_new_window.svg'
export { default as icon_pairing } from './src/icons/icon_pairing.svg'
export { default as icon_pc_smartphone } from './src/icons/icon_pc_smartphone.svg'
export { default as icon_person } from './src/icons/icon_person.svg'
export { default as icon_personalized_anc } from './src/icons/icon_personalized_anc.svg'
export { default as icon_phone } from './src/icons/icon_phone.svg'
export { default as icon_picture_in_picture } from './src/icons/icon_picture_in_picture.svg'
export { default as icon_play_pause } from './src/icons/icon_play_pause.svg'
export { default as icon_plus_filled } from './src/icons/icon_plus_filled.svg'
export { default as icon_plus } from './src/icons/icon_plus.svg'
export { default as icon_power } from './src/icons/icon_power.svg'
export { default as icon_press_one_time } from './src/icons/icon_press_one_time.svg'
export { default as icon_press_three_times } from './src/icons/icon_press_three_times.svg'
export { default as icon_press_two_times } from './src/icons/icon_press_two_times.svg'
export { default as icon_previous_track } from './src/icons/icon_previous_track.svg'
export { default as icon_price_tag } from './src/icons/icon_price_tag.svg'
export { default as icon_privacy_policy } from './src/icons/icon_privacy_policy.svg'
export { default as icon_qsg } from './src/icons/icon_qsg.svg'
export { default as icon_questions } from './src/icons/icon_questions.svg'
export { default as icon_raise_hand } from './src/icons/icon_raise_hand.svg'
export { default as icon_register } from './src/icons/icon_register.svg'
export { default as icon_reset } from './src/icons/icon_reset.svg'
export { default as icon_right_earbud } from './src/icons/icon_right_earbud.svg'
export { default as icon_right } from './src/icons/icon_right.svg'
export { default as icon_search } from './src/icons/icon_search.svg'
export { default as icon_settings_configurations } from './src/icons/icon_settings_configurations.svg'
export { default as icon_show } from './src/icons/icon_show.svg'
export { default as icon_sidetone } from './src/icons/icon_sidetone.svg'
export { default as icon_sleep_mode } from './src/icons/icon_sleep_mode.svg'
export { default as icon_smart_button } from './src/icons/icon_smart_button.svg'
export { default as icon_sms_reader } from './src/icons/icon_sms_reader.svg'
export { default as icon_spatial_sound } from './src/icons/icon_spatial_sound.svg'
export { default as icon_speaker_device } from './src/icons/icon_speaker_device.svg'
export { default as icon_speech_bubble } from './src/icons/icon_speech_bubble.svg'
export { default as icon_spotify } from './src/icons/icon_spotify.svg'
export { default as icon_statistics } from './src/icons/icon_statistics.svg'
export { default as icon_success_fill } from './src/icons/icon_success_fill.svg'
export { default as icon_success } from './src/icons/icon_success.svg'
export { default as icon_swipe_left } from './src/icons/icon_swipe_left.svg'
export { default as icon_switch_filled } from './src/icons/icon_switch_filled.svg'
export { default as icon_switch } from './src/icons/icon_switch.svg'
export { default as icon_system } from './src/icons/icon_system.svg'
export { default as icon_tap } from './src/icons/icon_tap.svg'
export { default as icon_text } from './src/icons/icon_text.svg'
export { default as icon_thumbs_up } from './src/icons/icon_thumbs_up.svg'
export { default as icon_tick_large } from './src/icons/icon_tick_large.svg'
export { default as icon_tick_small } from './src/icons/icon_tick_small.svg'
export { default as icon_tool_tip } from './src/icons/icon_tool_tip.svg'
export { default as icon_tools } from './src/icons/icon_tools.svg'
export { default as icon_trash } from './src/icons/icon_trash.svg'
export { default as icon_unlock_filled } from './src/icons/icon_unlock_filled.svg'
export { default as icon_unlock } from './src/icons/icon_unlock.svg'
export { default as icon_unpairing } from './src/icons/icon_unpairing.svg'
export { default as icon_upload_fill } from './src/icons/icon_upload_fill.svg'
export { default as icon_upload } from './src/icons/icon_upload.svg'
export { default as icon_user_manual } from './src/icons/icon_user_manual.svg'
export { default as icon_video_preset_1 } from './src/icons/icon_video_preset_1.svg'
export { default as icon_video_preset_2 } from './src/icons/icon_video_preset_2.svg'
export { default as icon_vivid_hdr } from './src/icons/icon_vivid_hdr.svg'
export { default as icon_voice_assistant } from './src/icons/icon_voice_assistant.svg'
export { default as icon_volume_minus } from './src/icons/icon_volume_minus.svg'
export { default as icon_volume_plus } from './src/icons/icon_volume_plus.svg'
export { default as icon_volume } from './src/icons/icon_volume.svg'
export { default as icon_warranty } from './src/icons/icon_warranty.svg'
export { default as icon_white_balance } from './src/icons/icon_white_balance.svg'
export { default as icon_whiteboard } from './src/icons/icon_whiteboard.svg'
export { default as icon_wifi } from './src/icons/icon_wifi.svg'
export { default as icon_chevron_small_down } from './src/icons/icon_chevron_small_down.svg'
export { default as icon_chevron_small_left } from './src/icons/icon_chevron_small_left.svg'
export { default as icon_chevron_small_right } from './src/icons/icon_chevron_small_right.svg'
export { default as icon_chevron_small_up } from './src/icons/icon_chevron_small_up.svg'
export { default as icon_basket } from './src/icons/icon_basket.svg'
export { default as icon_envelope } from './src/icons/icon_envelope.svg'
export { default as icon_maximize } from './src/icons/icon_maximize.svg'
export { default as icon_maximize_arrow } from './src/icons/icon_maximize_arrow.svg'
export { default as icon_minimize } from './src/icons/icon_minimize.svg'
export { default as icon_minimize_arrow } from './src/icons/icon_minimize_arrow.svg'
export { default as icon_180_degrees } from './src/icons/icon_180_degrees.svg'
export { default as icon_pause_circle } from './src/icons/icon_pause_circle.svg'
export { default as icon_pause } from './src/icons/icon_pause.svg'
export { default as icon_play_circle } from './src/icons/icon_play_circle.svg'
export { default as icon_play } from './src/icons/icon_play.svg'
export { default as icon_support_form } from './src/icons/icon_support_form.svg'
export { default as icon_facebook } from './src/icons/icon_facebook.svg'
export { default as icon_linkedin } from './src/icons/icon_linkedin.svg'
export { default as icon_x } from './src/icons/icon_x.svg'
export { default as icon_youtube } from './src/icons/icon_youtube.svg'
export { default as icon_headset_folded } from './src/icons/icon_headset_folded.svg'
